import { MenuItem, MenuItemProps } from '@csp/csp-web-ui';
import { FC } from 'react';

type AvatarMenuItemProps = MenuItemProps;

export const AvatarMenuItem: FC<AvatarMenuItemProps> = ({ sx, ...rest }) => (
  <MenuItem {...rest} sx={{ ...sx, padding: 2 }} />
);
